<template>
  <div class="toast fade show mt-2 mbr-snackbar" :class="getColor(color)">
    <div class="toast-header bg-transparent border-0">
      <!-- <i class="material-icons me-2" :class="getIcon(icon.color)">{{
        icon.component
      }}</i> -->
      <span class="mbr-snackbar__icon">
        <i class="fas" :class="getStatusIcon(color)" />
      </span>
      <div class="toast-body mbr-snackbar__text">{{ text }}</div>
      <span class="me-auto font-weight-bold mbr-snackbar__title">
        {{ title }}
      </span>
      <!-- <small :class="getTextColor(color)">{{ date }}</small> -->
      <i class="fas fa-times text-md ms-3 cursor-pointer mbr-snackbar__close" @click="closeHandler" />
    </div>
    <!-- <hr class="horizontal dark m-0" :class="getHrColor(color)" /> -->
    <!-- <div class="toast-body" :class="getTextColor(color)">{{ description }}</div> -->
  </div>
</template>

<script>
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "MaterialSnackbar",
  props: {
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: "",
    },
    // a string, or whatever a failed request left (axios error, API body, MessageBag)
    description: {
      type: [String, Object, Array, Error],
      default: "",
    },
    icon: {
      type: Object,
      component: String,
      color: String,
      default: () => { },
    },
    color: {
      type: String,
      default: "success",
    },

    closeHandler: {
      type: Function,
      default: () => { },
    },
  },
  computed: {
    // MBR125: never print a raw error object — reduce it to its readable message
    text() {
      if (!this.description || typeof this.description === "string") {
        return this.description;
      }

      return errorMessage(this.description);
    },
  },
  methods: {
    // White card for every status; the status only tints the icon and text
    getColor: (color) => {
      if (color === "danger" || color === "success" || color === "warning") {
        return `mbr-snackbar--${color}`;
      }

      return "mbr-snackbar--info";
    },
    getStatusIcon: (color) => {
      if (color === "danger" || color === "warning") {
        return "fa-exclamation";
      }

      return color === "success" ? "fa-check" : "fa-info";
    },
    getIcon: (iconColor) => (iconColor ? `text-${iconColor}` : null),
    getHrColor: (color) => (color === "white" ? "dark" : "light"),
  },
};
</script>

<style scoped>
.toast.mbr-snackbar {
  max-width: calc(100vw - 2 * var(--mbr-space-md));
  background: var(--mbr-color-surface);
  background-image: none;
  border: 0;
  border-radius: var(--mbr-radius-lg);
  box-shadow: var(--mbr-shadow-modal);
}

.mbr-snackbar .toast-header {
  display: flex;
  align-items: center;
  gap: var(--mbr-space-sm);
  padding: 12px 14px;
  border-radius: var(--mbr-radius-lg);
}

.mbr-snackbar__icon {
  display: inline-flex;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-tint);
  color: var(--mbr-color-label);
  font-size: 12px;
}

.mbr-snackbar .toast-body.mbr-snackbar__text {
  flex: 1 1 auto;
  padding: 0;
  font-family: var(--mbr-font-body);
  font-size: var(--mbr-label-md-size);
  font-weight: 600;
  line-height: var(--mbr-label-md-line);
  color: var(--mbr-color-ink-headline);
}

.mbr-snackbar__title {
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

.mbr-snackbar__close {
  flex: 0 0 auto;
  color: var(--mbr-color-ink-muted);
}

.mbr-snackbar--danger .mbr-snackbar__icon {
  background: var(--mbr-color-error-container);
  color: var(--mbr-color-error);
}

.mbr-snackbar--danger .toast-body.mbr-snackbar__text {
  color: var(--mbr-color-error);
}

.mbr-snackbar--success .mbr-snackbar__icon {
  color: var(--mbr-color-positive);
}

.mbr-snackbar--success .toast-body.mbr-snackbar__text {
  color: var(--mbr-color-positive);
}

.mbr-snackbar--warning .mbr-snackbar__icon {
  background: var(--mbr-color-peach);
}
</style>
